import { render, staticRenderFns } from "./TimelineDetails.vue?vue&type=template&id=647de3d6&scoped=true&"
import script from "./TimelineDetails.vue?vue&type=script&lang=js&"
export * from "./TimelineDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647de3d6",
  null
  
)

export default component.exports